import React, {useState} from 'react';
import HeatMap from "./HeatMap";
import PieChart from "./PieChart";

const ChartsBlock = ({allMarks}) => {
    const [days, setDays] = useState(7);
    const [chartNow, setChartNow] = useState("heatmap");

    return (
        <div className="chartsBlock">
            <span style={{display: "inline-block", fontSize: "22px", fontFamily: "'Source_Sans3_semibold', sans-serif", userSelect: "none"}} onClick={e => setChartNow(prev => prev === "heatmap" ? "pie" : "heatmap")}>{chartNow === "heatmap" ? "Тепловая карта" : "Диаграмма оценок"} →</span><br/>
            <span style={{display: "inline-block", color: "var(--beaut-blue-text)", fontFamily: "Source_Sans3_bold", marginBottom: "20px"}}>За последние <input type="number" value={days} min="1" max="9999999999999" onChange={e => {setDays(Number(e.target.value))}}/> дней</span>
            {chartNow === "heatmap" ?
                <HeatMap allMarks={allMarks} days={days} today={Date.now()}/> : <PieChart allMarks={allMarks} days={days} today={Date.now()} />}
        </div>
    );
};

export default ChartsBlock;